import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as actionsUi from './dokument-verwaltung.actions.ui';
import * as apiBenutzerverwaltung from '../../../../clients/benutzerverwaltung';
import {
    GET_DOKUMENT,
    GET_DOKUMENT_ERFOLGREICH,
    GET_DOKUMENT_FEHLER,
    GET_DOKUMENTE,
    GET_DOKUMENTE_ERFOLGREICH,
    GET_DOKUMENTE_FEHLER,
    GetDokumenteErfolgreichAction,
    GetDokumentErfolgreichAction,
    POST_DOKUMENT_HINZUFUEGEN,
    POST_DOKUMENT_HINZUFUEGEN_ERFOLGREICH,
    PostDokumentHinzufuegenAction,
    PostDokumentHinzufuegenErfolgreichAction
} from '../../../../client-ngrx/vorlagen';
import {ChecklisteDetail, Dokument, VeranstaltungsTyp} from '../../../../clients/vorlagen';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {AKTUELLES_DOKUMENT_TYPEN_SETZEN, AktuellesDokumentTypenSetzenAction} from './dokument-verwaltung.actions.ui';
import {getChecklisteDetail} from '../../checklisten/checklisten.reducer';

export interface RolleBenutzerCheckboxWrapper {
    selected: boolean;
    titel: string;
    benutzer: apiBenutzerverwaltung.RolleBenutzer;
}

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    dokumentListe: Array<Dokument>;
    dokumentListeUiLaden: boolean;
    dokumentListeUiFehler: boolean;
    dokumentListeUiFehlerObjekt: any;
    dokumentListeUiSelektiert: Dokument;
    istNeu: boolean;

    dokumentDetail: Dokument;
    dokumentDetailOriginal: Dokument;
    dokumentDetailUiLaden: boolean;
    dokumentDetailUiFehler: boolean;
    dokumentDetailUiFehlerObjekt: any;

    veranstaltungsTypenSelected: Array<string>;
}

export const initialPageState: PageState = {
    dokumentListe: [],
    dokumentListeUiLaden: false,
    dokumentListeUiFehler: false,
    dokumentListeUiFehlerObjekt: null,
    dokumentListeUiSelektiert: null,
    istNeu: false,

    dokumentDetail: null,
    dokumentDetailOriginal: null,
    dokumentDetailUiLaden: false,
    dokumentDetailUiFehler: false,
    dokumentDetailUiFehlerObjekt: null,

    veranstaltungsTypenSelected: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            // const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState>initialPageState);
        }


        case actionsUi.AKTUELLES_DOKUMENT_WURDE_AKTIVIERT: {
            return Object.assign({}, state, <PageState>{});
        }

        case actionsUi.AKTUELLES_DOKUMENT_WURDE_DEAKTIVIERT: {
            return Object.assign({}, state, <PageState>{});
        }

        // DOKUMENT LOESCHEN
        case actionsUi.AKTUELLES_DOKUMENT_WURDE_GELOESCHT: {
            return Object.assign({}, state, <PageState>{
                dokumentDetail: null,
                dokumentListeUiSelektiert: null
            });
        }


        // NEUES DOKUMENT
        case actionsUi.NEUES_DOKUMENT: {
            const a = <actionsUi.NeuesDokumentAction>action;
            // nur damit das ngFor neu gerendert wird
            const liste = state.dokumentListe.map(x => Object.assign({}, x));

            return Object.assign({}, state, <PageState>{
                dokumentDetail: a.dokument,
                dokumentListeUiSelektiert: null,
                dokumentListe: liste,
                istNeu: true
            });
        }

        case actionsUi.DOKUMENT_ABBRECHEN: {

            const liste = Object.assign([], state.dokumentListe);
            return Object.assign({}, state, state, <PageState>{
                dokumentDetail: null,
                dokumentListe: liste,
                dokumentListeUiSelektiert: null,
                istNeu: false
            });
        }

        case POST_DOKUMENT_HINZUFUEGEN: {
            const a = <PostDokumentHinzufuegenAction>action;
            return Object.assign({}, state, state, <PageState>{
                dokumentListeUiSelektiert: Object.assign({}, state.dokumentListeUiSelektiert, <Dokument>{dokument_id: a.dokumentHinzufuegenRequest.dokument_id})
            });
        }

        // DOKUMENTE LADEN (LISTE)
        case GET_DOKUMENTE: {
            return Object.assign({}, state, <PageState>{
                dokumentListeUiLaden: true
            });
        }

        case GET_DOKUMENTE_ERFOLGREICH: {
            const a = <GetDokumenteErfolgreichAction>action;

            let dokumentListeUiSelektiert: Dokument = null;
            if (state.dokumentListeUiSelektiert !== null) {
                dokumentListeUiSelektiert = Object.assign({}, state.dokumentListeUiSelektiert);
            }

            // Selektiertes Dokument ggf. entfernen, wenn nicht mehr in Liste enthalten
            if (state.dokumentListeUiSelektiert !== null && a.payload) {
                if (a.payload.findIndex(x => x.dokument_id === state.dokumentListeUiSelektiert.dokument_id) === -1) {
                    dokumentListeUiSelektiert = null;
                }
            }

            return Object.assign({}, state, <PageState>{
                dokumentListe: a.payload,
                dokumentListeUiSelektiert,
                dokumentListeUiLaden: false,
                dokumentListeUiFehler: false
            });
        }

        case GET_DOKUMENTE_FEHLER: {
            return Object.assign({}, state, <PageState>{
                dokumentListe: [],
                dokumentListeUiLaden: false,
                dokumentListeUiFehler: true
            });
        }

        case actionsUi.AKTUELLES_DOKUMENT_GESETZT: {
            const a = <actionsUi.AktuellesDokumentSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentListeUiSelektiert: a.dokument,
                istNeu: false
            });
        }

        case actionsUi.AKTUELLES_DOKUMENT_AENDERN: {
            const a = <actionsUi.AktuellesDokumentAendernAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentDetail: a.dokument,
                dokumentListeUiSelektiert: a.dokument
            });
        }


        // DOKUMENT LADEN
        case GET_DOKUMENT: {
            return Object.assign({}, state, <PageState>{
                dokumentDetailUiLaden: true
            });
        }

        case GET_DOKUMENT_ERFOLGREICH: {
            const a = <GetDokumentErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentDetail: a.payload,
                dokumentDetailOriginal: a.payload,
                dokumentDetailUiLaden: false,
                dokumentDetailUiFehler: false,
                dokumentListeUiSelektiert: a.payload,
                istNeu: false
            });
        }

        case GET_DOKUMENT_FEHLER: {
            return Object.assign({}, state, <PageState>{
                dokumentDetail: null,
                dokumentDetailOriginal: null,
                dokumentDetailUiLaden: false,
                dokumentDetailUiFehler: true
            });
        }

        case POST_DOKUMENT_HINZUFUEGEN_ERFOLGREICH  : {
            const a = <PostDokumentHinzufuegenErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                dokumentDetail: Object.assign({}, state.dokumentDetail, {dokument_id: a.dokumentHinzufuegenRequest.dokument_id}),
                dokumentDetailOriginal: Object.assign({}, state.dokumentDetail, {dokument_id: a.dokumentHinzufuegenRequest.dokument_id})
            });
        }

        case AKTUELLES_DOKUMENT_TYPEN_SETZEN: {
            const a = <AktuellesDokumentTypenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungsTypenSelected: a.payload
            });
        }

        default: {
            return state;
        }
    }


}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('DokumentverwaltungPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getDokumentListeUi = createSelector(getPageState, (state: PageState, filter: string) =>
    state.dokumentListe.map((item) => <ListInputItem>{
        groupId: item.gruppierung,
        groupTitle: item.gruppierung,
        itemId: item.dokument_id,
        itemTitle: item.titel,
        item: item,
    })
);
export const getDokumentListeUiLaden = createSelector(getPageState, (state: PageState) => state.dokumentListeUiLaden);
export const getDokumentListeUiFehler = createSelector(getPageState, (state: PageState) => state.dokumentListeUiFehler);
export const getDokumentListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.dokumentListeUiFehlerObjekt);
export const getDokumentListeUiSelektiert = createSelector(getPageState, (state: PageState) => state.dokumentListeUiSelektiert);

export const getIstNeu = createSelector(getPageState, (state: PageState) => state.istNeu);

export const getDokumentDetail = createSelector(getPageState, (state: PageState) => state.dokumentDetail);
export const getDokumentDetailUiLaden = createSelector(getPageState, (state: PageState) => state.dokumentDetailUiLaden);
export const getDokumentDetailUiFehler = createSelector(getPageState, (state: PageState) => state.dokumentDetailUiFehler);
export const getDokumentDetailUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.dokumentDetailUiFehlerObjekt);


export const getDokumentGeaendert = createSelector(getPageState, (state: PageState) => {
    return state.dokumentDetailOriginal !== state.dokumentDetail;
});

export const getVeranstaltungsTypen = createSelector(getDokumentDetail, (detail: Dokument) => {
    if (detail === null || detail === undefined || detail.veranstaltungstyp_liste === null || detail.veranstaltungstyp_liste === undefined) {
        return [];
    }

    return detail.veranstaltungstyp_liste.map((item: VeranstaltungsTyp) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.veranstaltungstyp_id,
        itemTitle: item.bezeichnung,
        item: item
    });
});

export const getVeranstaltungsTypenSelected = createSelector(getPageState, (state: PageState) => state.veranstaltungsTypenSelected);
